<template>
  <div>
    <LineChart :data="chartData.data" :labels="chartData.labels" :label="title" :color="color" :format-value="formatValue"/>
  </div>
</template>

<script setup>
import LineChart from "@/components/other/charts/LineChart.vue";
import {computed} from "vue";
import {utilities} from "@/niftybit";

const props = defineProps({
  data: Array,
  title: String,
  color: String,
  prefix: String,
  suffix: String
});

const chartData = computed(() => ({
  labels: props.data.map(item => utilities.formatDate(item.date)),
  data: props.data.map(item => item.value)
}));

function formatValue(item) {
  return (props.prefix ? props.prefix + " " : "") + item + (props.suffix ? " " + props.suffix : "");
}

</script>